import { useEffect, useState } from "react";
import { ISearchResult } from "./searchContextInterface";
import { SearchResultContext, SearchResultMutatorContext } from "./searchContext";

const SearchResultContextProvider = ({ children }) => {
  const [result, setResult] = useState<ISearchResult>();

  return (
    <SearchResultMutatorContext.Provider value={setResult}>
      <SearchResultContext.Provider value={result}>{children}</SearchResultContext.Provider>
    </SearchResultMutatorContext.Provider>
  );
};
export default SearchResultContextProvider;
